import { createSelectedCallMethodMessage } from 'calling-global-api/lib/internalEventMessageCreators';
import { postInternalMessage } from '../initialize';
import { triggerHostMessageSetCallMethod } from '../triggerHostMessage/triggerHostMessageSetCallMethod';
export default function setCallingMethodHandler({
  callMethod
}) {
  triggerHostMessageSetCallMethod(callMethod);
  const message = createSelectedCallMethodMessage(callMethod);
  postInternalMessage(message);
}